<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button type="primary" size="small" @click="addHardware"
            >新增打印机</el-button
          >
          <el-button type="primary" size="small" @click="addCloudHardware"
            >新增云打印机</el-button
          >
        </div>
      </div>
      <div class="tab-content">
        <div class="list">
          <el-table :data="printerList" style="width: 100%">
            <el-table-column label="打印机类型">
              <template slot-scope="scope">{{
                deviceType[scope.row.deviceType]
              }}</template>
            </el-table-column>
            <el-table-column label="打印机状态">
              <template slot-scope="scope">{{ scope.row.state }}</template>
            </el-table-column>
            <el-table-column label="设备名称/型号">
              <template slot-scope="scope">{{ scope.row.deviceName }}</template>
            </el-table-column>
            <el-table-column label="操作" header-align="right">
              <template slot-scope="scope">
                <div class="float-right">
                  <el-button size="small" type="primary" @click="edit(scope.$index)" plain
                    >编辑</el-button
                  >
                  <el-button
                    size="small"
                    type="danger"
                    @click="del(scope.row.printerDevicesId)"
                    plain
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogEditPrinterVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="510px"
    >
      <div slot="title" class="dialog-title">打印机编辑</div>
      <el-form
        :model="editPrinterForm"
        ref="editPrinterForm"
        label-width="108px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
        :validate-on-rule-change="false"
      >
        <el-form-item label="打印设备名称">
          <el-input v-model="editPrinterForm.deviceName"></el-input>
        </el-form-item>
        <el-form-item label="打印机类型">
          <el-input
            :disabled="true"
            v-model="deviceType[editPrinterForm.deviceType]"
          ></el-input>
        </el-form-item>
        <el-form-item label="纸张宽度">
          <el-select v-model="editPrinterForm.pageWidth" placeholder="请选择">
            <el-option
              v-for="item in pageWidthList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="桌位配置">
          <el-cascader
            placeholder="请选择桌位"
            v-model="editPrinterForm.shoppingTableIds"
            :options="tableList"
            :props="{ multiple: true }"
            filterable
          ></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmEdit" :loading="isSubmit"
          >确定</el-button
        >
        <el-button @click="dialogEditPrinterVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogAddHardwareVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="510px"
    >
      <div slot="title" class="dialog-title">打印机新增</div>
      <el-form
        :model="addHardwareForm"
        :rules="addHardwareFormRule"
        ref="addHardwareForm"
        label-width="108px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
        :validate-on-rule-change="false"
      >
        <el-form-item label="打印设备名称" prop="deviceName">
          <el-input
            v-model="addHardwareForm.deviceName"
            placeholder="请输入打印机名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="打印机">
          <el-select
            v-model="addHardwareForm.deviceIdentifier"
            placeholder="请选择打印机"
          >
            <el-option
              v-for="item in hardwareOptions"
              :key="item.deviceIdentifier"
              :label="item.deviceName"
              :value="item.deviceIdentifier"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="纸张宽度">
          <el-select v-model="addHardwareForm.pageWidth" placeholder="请选择">
            <el-option
              v-for="item in pageWidthList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="桌位配置">
          <el-cascader
            placeholder="请选择桌位"
            v-model="addHardwareForm.shoppingTableIds"
            :options="tableList"
            :props="{ multiple: true }"
            filterable
          ></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="confirmAdd('addHardwareForm')"
          :loading="isSubmit"
          >确定</el-button
        >
        <el-button @click="dialogAddHardwareVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogAddCloudHardwareVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="510px"
    >
      <div slot="title" class="dialog-title">
        {{ addCloudHardwareForm.printerDevicesId ? "打印机编辑" : "打印机新增" }}
      </div>
      <el-form
        :model="addCloudHardwareForm"
        :rules="addCloudHardwareFormRule"
        ref="addCloudHardwareForm"
        label-width="108px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
        :validate-on-rule-change="false"
      >
        <el-form-item label="打印设备名称" prop="deviceName">
          <el-input
            v-model="addCloudHardwareForm.deviceName"
            placeholder="请输入打印机名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="打印机设备号" prop="deviceIdentifier">
          <el-input
            v-model="addCloudHardwareForm.deviceIdentifier"
            placeholder="请输入打印机设备号"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="打印机密钥"
          prop="deviceCode"
          v-if="
            addCloudHardwareForm.printCompanyType != 4 &&
            addCloudHardwareForm.printCompanyType != 5 &&
            addCloudHardwareForm.printCompanyType != 6
          "
        >
          <el-input
            v-model="addCloudHardwareForm.deviceCode"
            placeholder="请输入打印机密钥"
          ></el-input>
        </el-form-item>
        <el-form-item label="云打印机类型">
          <el-select
            v-model="addCloudHardwareForm.printCompanyType"
            placeholder="请选择打印机"
          >
            <el-option
              v-for="item in cloudHardwareOptions"
              :key="item.deviceIdentifier"
              :label="item.deviceName"
              :value="item.deviceIdentifier"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="纸张宽度">
          <el-select v-model="addCloudHardwareForm.pageWidth" placeholder="请选择">
            <el-option
              v-for="item in pageWidthList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="桌位配置">
          <el-cascader
            placeholder="请选择桌位"
            v-model="addCloudHardwareForm.shoppingTableIds"
            :options="tableList"
            :props="{ multiple: true }"
            filterable
          ></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="confirmAdd('addCloudHardwareForm')"
          :loading="isSubmit"
          >确定</el-button
        >
        <el-button @click="dialogAddCloudHardwareVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getLodop } from "@/utils/LodopFuncs.js";
import {
  getPrinterDevices,
  addPrinterDevice,
  delPrinterDevices,
  batchSaveLocalPrint,
  getShopAreas,
  getShopTables,
} from "@/api";
export default {
  data() {
    return {
      printerList: [],
      dialogEditPrinterVisible: false,
      dialogAddHardwareVisible: false,
      dialogAddCloudHardwareVisible: false,
      editPrinterForm: {
        deviceType: 0,
        deviceName: "",
        deviceIdentifier: "",
        shoppingTableIds: "",
        pageWidth: 58,
      },
      addHardwareForm: {
        deviceType: 2,
        usePl: 0,
        channelId: 0,
        deviceName: "",
        deviceIdentifier: "",
        pageWidth: 58,
        shoppingTableIds: "",
      },
      addHardwareFormRule: {
        deviceName: [
          {
            required: true,
            message: "请填写打印机名称",
            trigger: "blur",
          },
        ],
      },
      addCloudHardwareForm: {
        deviceType: 1,
        usePl: 0,
        channelId: 0,
        deviceName: "",
        deviceIdentifier: "",
        shoppingTableIds: "",
        deviceCode: "",
        pageWidth: 58,
        printCompanyType: 1,
      },
      addCloudHardwareFormRule: {
        deviceName: [
          {
            required: true,
            message: "请填写打印机名称",
            trigger: "blur",
          },
        ],
        deviceIdentifier: [
          {
            required: true,
            message: "请填写打印机设备号",
            trigger: "blur",
          },
        ],
        deviceCode: [
          {
            required: true,
            message: "请选择打印机密钥",
            trigger: "blur",
          },
        ],
      },
      pageWidthList: [
        {
          value: 58,
          label: "58mm",
        },
        {
          value: 80,
          label: "80mm",
        },
      ],
      deviceType: {
        1: "云打印机",
        2: "PC本地打印机",
        3: "APP 蓝牙打印机",
        4: "App USB打印机",
        5: "网口打印机",
      },
      hardwareOptions: [],
      cloudHardwareOptions: [
        {
          deviceName: "易连云",
          deviceIdentifier: 1,
        },
        {
          deviceName: "飞鹅",
          deviceIdentifier: 2,
        },
        // {
        //     deviceName: "飞鱼",
        //     deviceIdentifier: 3
        // },
        {
          deviceName: "芯烨云",
          deviceIdentifier: 4,
        },
        {
          deviceName: "D2",
          deviceIdentifier: 5,
        },
        {
          deviceName: "芯烨云标签",
          deviceIdentifier: 6,
        },
        {
          deviceName: "飞鹅标签",
          deviceIdentifier: 7,
        },
        {
          deviceName: "商鹏打印机",
          deviceIdentifier: 9,
        },
      ],
      isSubmit: false,
      tableList: [
        {
          value: "0",
          label: "全选",
          children: [],
        },
      ],
      mapTableList: {},
    };
  },
  mounted() {
    this.getShopAreas();
    this.getPageData();
    setTimeout(() => {
      this.getLodopData();
    }, 1000);
  },
  methods: {
    getLodopData() {
      let LODOP = getLodop();
      console.log(LODOP);
      let arr = [];
      let iPrinterCount = LODOP.GET_PRINTER_COUNT();
      for (let i = 0; i < iPrinterCount; i++) {
        arr.push({
          deviceType: 2,
          deviceName: LODOP.GET_PRINTER_NAME(i),
          usePl: 0,
          deviceIdentifier: LODOP.GET_PRINTER_NAME(i),
          channelId: 0,
        });
      }
      let defaultName = LODOP.GET_PRINTER_NAME("-1"); //GET_PRINTER_NAME(intPrinterIndex);用序号获得打印机名，一般序号从0开始，-1特指默认打印机；
      arr.forEach((item) => {
        if (item.deviceIdentifier === defaultName) {
          this.addHardwareForm.deviceIdentifier = defaultName;
        }
      });
      // batchSaveLocalPrint({
      //     recordJson: JSON.stringify(arr)
      // }).then(res => {
      //     if (res.code == 1) {
      //         console.log(res);
      //     }
      // });
      this.hardwareOptions = arr;
    },
    addHardware() {
      this.addHardwareForm.deviceName = "";
      this.dialogAddHardwareVisible = true;
    },
    addCloudHardware() {
      this.addCloudHardwareForm = {
        deviceType: 1,
        deviceIdentifier: "",
        shoppingTableIds: "",
        deviceCode: "",
        pageWidth: 58,
        printCompanyType: 1,
      };
      this.dialogAddCloudHardwareVisible = true;
    },
    confirmAdd(type) {
      if (type == "addHardwareForm") {
        this.$refs.addHardwareForm.validate((valid) => {
          if (valid) {
            this.isSubmit = true;
            let Param = Object.assign({}, this.addHardwareForm);
            Param.shoppingTableIds = "";
            if (this.addHardwareForm.shoppingTableIds) {
              console.log(this.addHardwareForm.shoppingTableIds);
              this.addHardwareForm.shoppingTableIds.forEach((val, index) => {
                if (this.addHardwareForm.shoppingTableIds.length == index + 1) {
                  Param.shoppingTableIds += val[2];
                } else {
                  Param.shoppingTableIds += `${val[2]},`;
                }
              });
            }
            batchSaveLocalPrint({
              recordJson: JSON.stringify([Param]),
            }).then((res) => {
              if (res.code == 1) {
                this.getPageData();
                this.dialogAddHardwareVisible = false;
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
              this.isSubmit = false;
            });
          } else {
            this.$notify({
              title: "提示",
              message: "请完善提交内容",
              type: "error",
              duration: 2000,
            });
            return false;
          }
        });
      }
      if (type == "addCloudHardwareForm") {
        this.$refs.addCloudHardwareForm.validate((valid) => {
          if (valid) {
            this.isSubmit = true;
            let Param = Object.assign({}, this.addCloudHardwareForm);
            Param.shoppingTableIds = "";
            if (this.addCloudHardwareForm.shoppingTableIds) {
              console.log(this.addCloudHardwareForm.shoppingTableIds);
              this.addCloudHardwareForm.shoppingTableIds.forEach((val, index) => {
                if (this.addCloudHardwareForm.shoppingTableIds.length == index + 1) {
                  Param.shoppingTableIds += val[2];
                } else {
                  Param.shoppingTableIds += `${val[2]},`;
                }
              });
            }
            if (
              this.addCloudHardwareForm.printCompanyType == 4 ||
              this.addCloudHardwareForm.printCompanyType == 5 ||
              this.addCloudHardwareForm.printCompanyType == 6
            ) {
              Param.deviceCode = this.addCloudHardwareForm.deviceIdentifier;
            }
            batchSaveLocalPrint({
              recordJson: JSON.stringify([Param]),
            }).then((res) => {
              if (res.code == 1) {
                this.getPageData();
                this.dialogAddCloudHardwareVisible = false;
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
              this.isSubmit = false;
            });
          } else {
            this.$notify({
              title: "提示",
              message: "请完善提交内容",
              type: "error",
              duration: 2000,
            });
            return false;
          }
        });
      }
    },
    getPageData() {
      this.getPrinterDevices();
    },
    getPrinterDevices() {
      getPrinterDevices({
        hasState: 1,
      }).then((res) => {
        if (res.code == 1) {
          this.printerList = res.data;
        }
      });
    },
    confirmEdit() {
      this.isSubmit = true;
      let Param = Object.assign({}, this.editPrinterForm);
      Param.shoppingTableIds = "";
      if (this.editPrinterForm.shoppingTableIds) {
        console.log(this.editPrinterForm.shoppingTableIds);
        this.editPrinterForm.shoppingTableIds.forEach((val, index) => {
          if (this.editPrinterForm.shoppingTableIds.length == index + 1) {
            Param.shoppingTableIds += val[2];
          } else {
            Param.shoppingTableIds += `${val[2]},`;
          }
        });
      }
      addPrinterDevice(Param).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "编辑成功",
            type: "success",
            duration: 2000,
          });
          this.getPageData();
          this.dialogEditPrinterVisible = false;
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
        setTimeout(() => {
          this.isSubmit = false;
        }, 500);
      });
    },
    edit(index) {
      if (this.printerList[index].deviceType != 1) {
        this.editPrinterForm = {
          deviceType: 0,
          deviceName: "",
          deviceIdentifier: "",
          shoppingTableIds: "",
          pageWidth: 58,
        };
        this.editPrinterForm = Object.assign(
          this.editPrinterForm,
          this.printerList[index]
        );
        if (
          this.editPrinterForm.shoppingTableIds &&
          this.editPrinterForm.shoppingTableIds.length
        ) {
          this.editPrinterForm.shoppingTableIds = this.editPrinterForm.shoppingTableIds.split(
            ","
          );
          this.editPrinterForm.shoppingTableIds.forEach((val, index) => {
            this.editPrinterForm.shoppingTableIds[index] = [
              "0",
              this.mapTableList[val] && this.mapTableList[val].shopAreaId,
              Number(val),
            ];
          });
          console.log(this.editPrinterForm);
        }
        this.dialogEditPrinterVisible = true;
      } else {
        this.addCloudHardwareForm = {
          deviceType: 1,
          usePl: 0,
          channelId: 0,
          deviceName: "",
          deviceIdentifier: "",
          shoppingTableIds: "",
          deviceCode: "",
          pageWidth: 58,
          printCompanyType: 1,
        };
        this.addCloudHardwareForm = Object.assign(
          this.addCloudHardwareForm,
          this.printerList[index]
        );
        if (
          this.addCloudHardwareForm.shoppingTableIds &&
          this.addCloudHardwareForm.shoppingTableIds.length
        ) {
          this.addCloudHardwareForm.shoppingTableIds = this.addCloudHardwareForm.shoppingTableIds.split(
            ","
          );
          this.addCloudHardwareForm.shoppingTableIds.forEach((val, index) => {
            console.log(this.mapTableList, this.mapTableList[val]);
            this.addCloudHardwareForm.shoppingTableIds[index] = [
              "0",
              this.mapTableList[val] && this.mapTableList[val].shopAreaId,
              Number(val),
            ];
          });
        }
        this.dialogAddCloudHardwareVisible = true;
      }
    },
    del(id) {
      this.$msgbox({
        title: "消息",
        message: `是否删除，删除后将无法恢复！`,
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            delPrinterDevices({
              printerDevicesId: id,
            }).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "删除成功",
                  type: "success",
                  duration: 1000,
                });
                this.getPageData();
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
            });
            done();
          } else {
            done();
          }
        },
      }).then((action) => {});
    },
    getShopAreas() {
      getShopAreas({
        row: 1000,
      }).then((res) => {
        if (res.code == 1) {
          let list = [];
          res.data.forEach((val, index) => {
            list[index] = {};
            list[index].value = val.shopAreaId;
            list[index].label = val.areaName;
          });
          this.tableList[0].children = JSON.parse(JSON.stringify(list));
          this.tableList[0].children.forEach((val, index) => {
            this.getShopTables(val.value, index);
          });
        }
      });
    },
    getShopTables(shopAreaId, index) {
      getShopTables({
        shopAreaId: shopAreaId,
        status: this.shopTableStatus,
        row: 1000,
      }).then((tablesRes) => {
        this.tableList[0].children[index].children = [];
        if (tablesRes.code == 1) {
          tablesRes.data.forEach((val) => {
            this.tableList[0].children[index].children.push({
              label: val.tableName,
              value: val.shoppingTableId,
            });
            this.mapTableList[val.shoppingTableId] = {
              shopAreaId: shopAreaId,
              shoppingTableId: val.shoppingTableId,
            };
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-content {
    display: block;
    padding: 0 20px;
  }
  .el-cascader,
  .el-select {
    width: 100%;
  }
}
</style>

<style lang="less">
.el-form-item__content {
  .el-input-group__append {
    background: #fff;
  }
}
</style>
